import {
  ApiPropertyOptional,
  IntersectionType,
  PartialType,
  PickType,
} from '@nestjs/swagger';
import { IsBoolean, IsOptional } from 'class-validator';
import { Expose, Type } from 'class-transformer';
import { JobPhaseBumpCreatableInterface } from '../interfaces/job-phase-bump-creatable.interface';
import { JobPhaseBumpDto } from './job-phase-bump.dto';

export class JobPhaseBumpCreateDto
  extends IntersectionType(
    PickType(JobPhaseBumpDto, ['jobPhaseId', 'contractorId', 'date']),
    PartialType(PickType(JobPhaseBumpDto, ['loggedGeo', 'loggedGeoAccuracy'])),
  )
  implements JobPhaseBumpCreatableInterface
{
  @ApiPropertyOptional({
    type: 'boolean',
    title: 'Trim Option Selected?',
    description:
      'Trim option selection forwarded to the related job phase; not stored on the bump itself',
  })
  @IsOptional()
  @IsBoolean()
  @Type(() => Boolean)
  @Expose()
  trimOptionSelected?: boolean;

  @ApiPropertyOptional({
    type: 'boolean',
    title: 'Interior options finished?',
    description:
      'Recorded on the job (with this phase as the finishing phase) in the same transaction as the bump log; not stored on the bump itself',
  })
  @IsOptional()
  @IsBoolean()
  @Type(() => Boolean)
  @Expose()
  interiorOptionsFinished?: boolean;

  @ApiPropertyOptional({
    type: 'boolean',
    title: 'Exterior options finished?',
    description:
      'Recorded on the job (with this phase as the finishing phase) in the same transaction as the bump log; not stored on the bump itself',
  })
  @IsOptional()
  @IsBoolean()
  @Type(() => Boolean)
  @Expose()
  exteriorOptionsFinished?: boolean;
}
